(function () {
  "use strict";

  var soportaIO = typeof IntersectionObserver === "function";

  var io = soportaIO ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
    });
  }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }) : null;

  // Revela de inmediato, sin esperar al scroll. Lo usa el AJAX del filtro de
  // colecciones y el editor de temas, donde el observer ya corrio y no ve
  // los nodos que llegan despues por fetch.
  function revelar(raiz) {
    var r = raiz || document;
    if (r.classList && r.classList.contains("rev")) r.classList.add("in");
    if (r.querySelectorAll) {
      r.querySelectorAll(".rev").forEach(function (el) { el.classList.add("in"); });
    }
  }
  window.fcRevelar = revelar;

  // Pone bajo observacion los .rev que aun no se han revelado.
  function observar(raiz) {
    var r = raiz || document;
    if (!io) { revelar(r); return; }
    if (r.classList && r.classList.contains("rev") && !r.classList.contains("in")) io.observe(r);
    if (r.querySelectorAll) {
      r.querySelectorAll(".rev:not(.in)").forEach(function (el) { io.observe(el); });
    }
  }
  observar(document);

  var toast = document.getElementById("toast");
  var toastTxt = document.getElementById("toastTxt");
  var toastT = null;
  // Los avisos largos (compra minima) se acomodan en dos lineas sin salirse
  // de la pantalla: la pastilla pasa a tarjeta y dura mas tiempo visible.
  function ping(msg, ms) {
    if (!toast) return;
    toastTxt.textContent = msg;
    var largo = msg.length > 34;
    toast.style.maxWidth = "calc(100vw - 32px)";
    toast.style.width = largo ? "max-content" : "";
    toast.style.borderRadius = largo ? "16px" : "";
    toast.style.lineHeight = largo ? "1.4" : "";
    toast.classList.add("show");
    clearTimeout(toastT);
    toastT = setTimeout(function () { toast.classList.remove("show"); }, ms || (largo ? 4800 : 2400));
  }

  // Compra minima en tienda: $1,000 MXN sin IVA por orden (en centavos).
  // Solo aplica a la tienda; el cotizador KAM y la cotizacion compleja no la usan.
  var FC_MIN = 100000;

  function money(cents) {
    return "$" + (cents / 100).toLocaleString("es-MX", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function updRenta() {
    var box = document.querySelector("[data-renta]");
    if (!box) return;
    var out = document.getElementById("rentaQtyOut");
    var tot = document.getElementById("rentaTotal");
    var lbl = document.getElementById("rentaTotalLbl");
    if (!out || !tot) return;
    var qty = parseInt(out.textContent, 10) || 0;
    var precio = parseInt(box.getAttribute("data-precio"), 10) || 0;
    tot.textContent = money(qty * precio);
    if (lbl) lbl.textContent = "+ IVA al mes por " + qty + " piezas";
  }
  updRenta();

  // Nota de compra minima en la ficha de producto: cuantas piezas cubren el
  // minimo con este producto solo, y si la cantidad elegida ya lo cubre.
  function updMinP() {
    var box = document.getElementById("fcMinP");
    if (!box) return;
    var min = parseInt(box.getAttribute("data-min"), 10) || FC_MIN;
    var p = parseInt(box.getAttribute("data-precio"), 10) || 0;
    var u = box.getAttribute("data-u") || "piezas";
    var out = document.getElementById("qtyOut");
    var q = out ? (parseInt(out.textContent, 10) || 1) : 1;
    var n = p > 0 && p < min ? Math.ceil(min / p) : 1;
    var ok = p > 0 && q * p >= min;
    var txt = document.getElementById("fcMinPTxt");
    var btn = document.getElementById("fcMinPBtn");
    box.classList.toggle("ok", ok);
    if (txt) {
      if (n <= 1) txt.textContent = "Este producto cubre la compra mínima.";
      else if (ok) txt.textContent = "Con " + q + " " + u + " cubres la compra mínima.";
      else txt.textContent = "Con este producto solo, desde " + n + " " + u + ". También puedes combinarlo con otros productos.";
    }
    if (btn) {
      btn.setAttribute("data-qty-set", n);
      btn.textContent = "Usar " + n;
      btn.hidden = n <= 1 || ok;
    }
  }
  updMinP();

  // Editor de temas: cada cambio de ajuste reemplaza la seccion por AJAX.
  // Los nodos nuevos nacen en opacity:0 y el observer inicial ya no los ve,
  // asi que en el editor se revelan de golpe y se recalculan los totales.
  var enEditor = !!(window.Shopify && window.Shopify.designMode);
  document.addEventListener("shopify:section:load", function (e) {
    if (enEditor) revelar(e.target); else observar(e.target);
    updRenta();
    updMinP();
  });
  document.addEventListener("shopify:section:select", function (e) { if (enEditor) revelar(e.target); });
  document.addEventListener("shopify:section:reorder", function () { if (enEditor) revelar(document); });
  document.addEventListener("shopify:block:select", function (e) { if (enEditor) revelar(e.target); });

  function setBadge(n) {
    var b = document.getElementById("cartCount");
    if (!b) return;
    b.textContent = n;
    b.classList.toggle("is-empty", n === 0);
  }

  document.addEventListener("click", function (ev) {

    var q = ev.target.closest("[data-qty]");
    if (q) {
      var out = document.getElementById(q.getAttribute("data-target") || "qtyOut");
      if (!out) return;
      var step = parseInt(q.getAttribute("data-step"), 10) || 1;
      var min = parseInt(q.getAttribute("data-min") || "1", 10);
      var n = Math.max(min, (parseInt(out.textContent, 10) || min) + step);
      out.textContent = n;
      if (out.id === "rentaQtyOut") updRenta();
      if (out.id === "qtyOut") updMinP();
      return;
    }

    var qs = ev.target.closest("[data-qty-set]");
    if (qs) {
      var outS = document.getElementById(qs.getAttribute("data-target") || "qtyOut");
      var nS = parseInt(qs.getAttribute("data-qty-set"), 10) || 1;
      if (!outS) return;
      outS.textContent = nS;
      outS.classList.remove("fc-qty-pop"); void outS.offsetWidth; outS.classList.add("fc-qty-pop");
      updMinP();
      return;
    }

    var th = ev.target.closest("[data-thumb]");
    if (th) {
      var main = document.getElementById("galMain");
      if (main) main.src = th.getAttribute("data-thumb");
      document.querySelectorAll("[data-thumb]").forEach(function (t) { t.classList.remove("act"); });
      th.classList.add("act");
      return;
    }

    var add = ev.target.closest("[data-add]");
    if (add && !add.disabled) {
      var variant = parseInt(add.getAttribute("data-variant"), 10);
      if (!variant) return;
      var qty = 1;
      var outId = add.getAttribute("data-out");
      if (outId) {
        var o = document.getElementById(outId);
        if (o) qty = parseInt(o.textContent, 10) || 1;
      }
      add.disabled = true;
      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ items: [{ id: variant, quantity: qty }] })
      })
        .then(function (r) { if (!r.ok) throw new Error("add"); return fetch("/cart.js"); })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          setBadge(c.item_count);
          var total = c.total_price || 0;
          var linea = (c.items || []).filter(function (it) { return it.variant_id === variant; })[0];
          var antes = total - (linea ? (linea.final_price || linea.price || 0) * qty : 0);
          if (total < FC_MIN) ping("Agregado. Te faltan " + money(FC_MIN - total) + " para la compra mínima de $1,000 + IVA.");
          else if (antes < FC_MIN) ping("Agregado. Tu carrito ya cubre la compra mínima.");
          else ping("Agregado al carrito");
        })
        .catch(function () { ping("No se pudo agregar. Intente de nuevo."); })
        .finally(function () { add.disabled = false; });
      return;
    }
  });

  document.addEventListener("change", function (ev) {
    var s = ev.target.closest("[data-sort]");
    if (s) {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", s.value);
      window.location.href = url.toString();
      return;
    }
    var vs = ev.target.closest("[data-varsel]");
    if (vs) {
      var opt = vs.options[vs.selectedIndex];
      document.querySelectorAll('[data-add][data-out="qtyOut"]').forEach(function (b) {
        b.setAttribute("data-variant", vs.value);
      });
      var p = document.getElementById("pdpPrice");
      if (p && opt.getAttribute("data-price")) p.textContent = opt.getAttribute("data-price");
      var mp = document.getElementById("fcMinP");
      if (mp && opt.getAttribute("data-cents")) { mp.setAttribute("data-precio", opt.getAttribute("data-cents")); updMinP(); }
      return;
    }
  });

  var sticky = document.querySelector("[data-autoshow]");
  if (sticky) setTimeout(function () { sticky.classList.add("is-show"); }, 500);
})();
